import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { createExperience } from "./actions";

const NewExperienceForm = ({ experiences = [], onCreatePressed }) => {

    const [position, setPosition] = useState('');
    const [company, setCompany] = useState('');
    const [desc, setDesc] = useState('');
    const [start, setStartDate] = useState('');
    const [end, setEndDate] = useState('');
    const [presentJob, setPresentJob] = useState(false);
    const [location, setLocation] = useState('');
    const [jobType, setJobType] = useState('');

    useEffect(() => {
        if (presentJob) {
            setEndDate('');
        }
    }, [presentJob]);

    return (
        <div className="border rounded bg-light p-3 m-2">
            <div style={{ display: 'flex', justifyContent: 'start', gap: '10px', marginBottom: '7px' }}>
                <div>
                    <label style={{ margin: '0', padding: '0' }} htmlFor="position">Company</label>
                    <input
                        className="form-control mb-2"
                        type="text"
                        placeholder="Company"
                        value={company}
                        onChange={e => setCompany(e.target.value)}
                        style={{ width: '580px' }}
                    />
                </div>
                <div className="role">
                    <label style={{ margin: '0', padding: '0' }} htmlFor="position">Job Type</label>
                    <select
                        style={{ marginTop: '5px' }}
                        className="form-control"
                        value={jobType}
                        onChange={e => setJobType(e.target.value)}>
                        <option value="">Select Job Type</option>
                        <option value="Full Time">Full Time</option>
                        <option value="Part Time">Part Time</option>
                        <option value="Internship">Internship</option>
                        <option value="Contract">Contract</option>
                    </select>
                </div>
                <div>
                    <label style={{ margin: '0', padding: '0' }} htmlFor="position">Role</label>
                    <input
                        className="form-control mb-2"
                        type="text"
                        placeholder="Position"
                        value={position}
                        onChange={e => setPosition(e.target.value)}
                    />
                </div>
            </div>
            <div style={{ marginBottom: '7px' }}>
                <div style={{ display: 'flex', justifyContent: 'start', gap: '10px' }}>
                    <div>
                        <label style={{ margin: '0', padding: '0' }} htmlFor="position">Location</label>
                        <input
                            className="form-control mb-2"
                            type="text"
                            placeholder="Location"
                            value={location}
                            onChange={e => setLocation(e.target.value)}
                        />
                    </div>
                    <div>
                        <label style={{ margin: '0', padding: '0', display: 'block' }} htmlFor="position">Start Date</label>
                        <input
                            className="form-control mb-2"
                            type="month"
                            value={start}
                            onChange={e => setStartDate(e.target.value)}
                            cleared={() => setStartDate('')}
                            placeholder="Start Date"
                            style={{ width: '200px' }}
                        />
                    </div>
                    <div>
                        <label style={{ margin: '0', padding: '0', display: 'block' }} htmlFor="position">End Date</label>
                        <input
                            className="form-control mb-2"
                            type="month"
                            placeholder="End Date"
                            value={end}
                            onChange={(e) => setEndDate(e.target.value)}
                            cleared={() => setEndDate('')}
                            disabled={presentJob}
                            style={{ width: '200px' }}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px', marginLeft: '15px' }}>
                        <input
                            type="checkbox"
                            id="presentJob"
                            name="presentJob"
                            checked={presentJob}
                            onChange={() => setPresentJob(!presentJob)}
                        />
                        <label htmlFor="presentJob"
                            style={{ margin: '0' }}>I am currently working here</label>
                    </div>
                </div>
            </div>
            <div style={{ marginBottom: 5 }}>
                <label style={{ margin: '0', padding: '0' }} htmlFor="position">Description</label>
                <textarea
                    style={{ width: '100%' }}
                    className="form-control mb-2 w-100"
                    placeholder="Role description"
                    rows="3"
                    value={desc}
                    onChange={e => setDesc(e.target.value)}
                />
            </div>
            <div style={{ display: 'flex', justifyContent: 'end' }}>
                <button
                    className="btn btn-success btn-sm rounded-circle"
                    disabled={position === '' ||
                        company === '' ||
                        desc === '' ||
                        start === '' ||
                        (end === '' && !presentJob)
                    }
                    onClick={() => {
                        onCreatePressed({ position, company, desc, jobType, start, end, presentJob, location });
                        setPosition('');
                        setCompany('');
                        setDesc('')
                        setStartDate('');
                    }}
                >
                    {/* <FontAwesomeIcon icon={faPlus} /> */}
                    Add
                </button>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    experiences: state.experiences,
});

const mapDispatchToProps = dispatch => ({
    onCreatePressed: experience => dispatch(createExperience(experience)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewExperienceForm);
